import SvgNotfound from "@/assets/illustrations/not-found.svg";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <div className="h-screen flex justify-center items-center">
      <div className="text-center">
        <img src={SvgNotfound} alt="not found" />
        <h1 className="mt-20 mb-10 font-bold text-4xl">
          Halaman tidak ditemukan
        </h1>
        <Link to={"/"}>
          <Button>Kembali ke Beranda</Button>
        </Link>
      </div>
    </div>
  );
}
